export default "__VITE_ASSET__Y3QBfne___"